import { AppointmentTypeDto } from "core/gateways/practice/location.dtos";

export interface AppointmentTypeCombined extends AppointmentTypeDto {
  groupBooking?: boolean;
  maxGroupSize?: number;
  durationTG?: number;
  bookingStatus?: BookingStatus;
  premId?: number;
}

export enum BookingStatus {
  Online = "1",
  Offline = "0",
  CallClinic = "2"
}
